import React from "react";
import { Chart as ChartJS, ArcElement } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(ArcElement);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
    datalabels: {
      color: "#fff",
      textStrokeColor: "black", // <-- added this
      textStrokeWidth: 3, // <-- added this,
      display: false,
    },
  },
};

const GaugeChart = ({ data, fontSize }) => {
  if (!fontSize) fontSize = 16;
  const centerText = {
    id: "centerText",
    afterDatasetsDraw: (chart) => {
      const { ctx, data } = chart;
      const text =
        parseFloat(
          (data.datasets[0].data[0] /
            (data.datasets[0].data[0] + data.datasets[0].data[1])) *
            100
        ).toFixed(0) + "%";
      ctx.save();
      const x = chart.getDatasetMeta(0).data[0].x;
      const y = chart.getDatasetMeta(0).data[0].y;
      ctx.textAlign = "center";
      ctx.textBaseLine = "middle";
      ctx.font = `bold ${fontSize}px sans-serif`;
      ctx.fillText(text, x, y - y / 15);
    },
  };

  return (
    <Doughnut
      options={options}
      data={data}
      plugins={[centerText, ChartDataLabels]}
    />
  );
};

export default GaugeChart;
